import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useIsSuperAdmin = () => {
  const { user, loading: authLoading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkSuperAdminRole = async () => {
      if (!user) {
        if (mounted) {
          setIsSuperAdmin(false);
          setLoading(false);
        }
        return;
      }

      try {
        const { data, error } = await supabase.rpc('has_super_admin_role', {
          _user_id: user.id
        });

        if (!mounted) return;

        if (error) {
          console.error('Error checking super admin role:', error);
          setIsSuperAdmin(false);
        } else {
          setIsSuperAdmin(data === true);
        }
      } catch (err) {
        console.error('Exception checking super admin role:', err);
        if (mounted) {
          setIsSuperAdmin(false);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    if (!authLoading) {
      checkSuperAdminRole();
    }

    return () => {
      mounted = false;
    };
  }, [user, authLoading]);

  return { isSuperAdmin, loading: loading || authLoading };
};
